<template>
  <el-dialog title="请确认您的操作" :visible.sync="dialogVisible" width="30%" @close="handleClose">
    <div class="confirm-content">
      <p>确定取消授权吗？</p>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">点错了</el-button>
      <el-button type="primary" @click="handleConfirm">确认删除</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { deleteRoleShop } from '@/api/frame/roleShopApi'

export default {
  name: 'DeleteRoleShop',
  data() {
    return {
      dialogVisible: false,
      formData: {
        roleId: '',
        rcId:'',
        shopId: ''
      }
    }
  },
  methods: {
    open(roleShop) {
      this.formData = {
        roleId: roleShop.roleId,
        rcId: roleShop.rcId,
        shopId: roleShop.shopId
      }
      this.dialogVisible = true
    },
    async handleConfirm() {
      try {
        const res = await deleteRoleShop(this.formData)
        if (res.code === 0) {
          this.$message.success('删除成功')
          this.dialogVisible = false
          this.$emit('refresh')
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.error('删除店铺授权失败:', error)
        this.$message.error('删除店铺授权失败')
      }
    },
    handleClose() {
      this.formData = {
        roleId: '',
        shopId: ''
      }
    }
  }
}
</script>

<style scoped>
.confirm-content {
  text-align: center;
  margin-bottom: 20px;
}
</style>